import { IoHomeOutline } from "react-icons/io5";
import { LuSchool } from "react-icons/lu";

import Input from "@/components/input/Input";
import Select from "@/components/select/Select";

function EducationInputs({
    isRequired,
    register,
    isPending,
    errors,
    ApiError,
    watch,
    setValue,
}) {
    const data = [
        { value: "1", text: "الصف الاول الثانوي" },
        { value: "2", text: "الصف الثاني الثانوي" },
        { value: "3", text: "الصف الثالث الثانوي" },
    ];
    return (
        <>
            {/* grade */}

            <Select
                name="grade"
                label={"الصف الدراسي*"}
                options={data}
                setValue={setValue}
                watch={watch}
                disabled={isPending}
                register={register("grade", {
                    ...(isRequired ? { required: isRequired } : {}),
                })}
                error={
                    errors?.grade?.message ||
                    ApiError?.response?.data?.errors?.grade?.[0]
                }
            />
            <div className="flex gap-4">
                {/* City */}
                <Input
                    type="text"
                    name="city"
                    id="city"
                    label="المدينة*"
                    disabled={isPending}
                    icon={IoHomeOutline}
                    register={register("city", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={
                        errors?.city?.message ||
                        ApiError?.response?.data?.errors?.city?.[0]
                    }
                />
                {/* School */}
                <Input
                    type="text"
                    name="school"
                    id="school"
                    label="المدرسة*"
                    disabled={isPending}
                    icon={LuSchool}
                    register={register("school", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={errors?.school?.message}
                />
            </div>
        </>
    );
}

export default EducationInputs;
